import { render } from "./PropertyControl.vue?vue&type=template&id=19ff1739&scoped=true"
import script from "./PropertyControl.vue?vue&type=script&lang=js"
export * from "./PropertyControl.vue?vue&type=script&lang=js"

import "./PropertyControl.vue?vue&type=style&index=0&id=19ff1739&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ff1739"]])

export default __exports__